import { configureStore } from '@reduxjs/toolkit'
import { WorkflowReducer } from './Reducers/WorkflowReducer'

export default configureStore({
  reducer: {
  	workflows: WorkflowReducer
  }
})